export enum AuthActionTypes {
  REQUEST_LOGIN_USER = '@auth/REQUEST_LOGIN_USER',
  REQUEST_LOGIN_USER_SUCCESS = '@auth/REQUEST_LOGIN_USER_SUCCESS',
  REQUEST_LOGIN_USER_ERROR = '@auth/REQUEST_LOGIN_USER_ERROR',
  REQUEST_USER_LOGOUT = '@auth/REQUEST_USER_LOGOUT',
  USER_LOGOUT = '@auth/USER_LOGOUT',
  USER_COMP_LOGOUT = '@auth/USER_COMP_LOGOUT',
  REMOVE_ERROR_LOGIN = '@auth/REMOVE_ERROR_LOGIN',
}
